/* eslint-disable import/no-cycle */
import { Record, RecordOf } from 'immutable';

import { StandardAction } from '../types';
import SelectedAppointmentContactAction from './selected-contact.action';
import { ISelectedAppointmentContactState } from './types';

const initData: ISelectedAppointmentContactState = {
  id: '',
  description: '',
  totalUnreadMessages: 0,
  active: false,
  date: '',
  chatRoom: {},
};

const initialState = Record(initData)(initData);

export default class SelectedAppointmentContactReducer {
  static getReducer(
    state: RecordOf<ISelectedAppointmentContactState> = initialState,
    action: StandardAction,
  ): RecordOf<ISelectedAppointmentContactState> {
    switch (action.type) {
      // Upload SelectedAppointmentContact
      case SelectedAppointmentContactAction.TYPES.SET_SELECTED_APPOINTMENT_CONTACT:
      case SelectedAppointmentContactAction.TYPES.DESELECT_APPOINTMENT_CONTACT:
        return SelectedAppointmentContactReducer.handleSetSelectedAppointmentContact(state, action);

      default:
        return state;
    }
  }

  // handle upload selectedAppointmentContact
  static handleSetSelectedAppointmentContact = (
    state: RecordOf<ISelectedAppointmentContactState>,
    action: StandardAction<ISelectedAppointmentContactState>,
  ): RecordOf<ISelectedAppointmentContactState> => {
    switch (action.type) {
      case SelectedAppointmentContactAction.TYPES.SET_SELECTED_APPOINTMENT_CONTACT:
        return {
          ...state,
          ...action.payload,
        };

      case SelectedAppointmentContactAction.TYPES.DESELECT_APPOINTMENT_CONTACT:
        return {
          ...state,
          id: '',
          description: '',
        };

      default:
        return state;
    }
  };
}
